import { render } from "./ClientsActionModal.vue?vue&type=template&id=be48cdb6&scoped=true"
import script from "./ClientsActionModal.vue?vue&type=script&lang=js"
export * from "./ClientsActionModal.vue?vue&type=script&lang=js"

import "./ClientsActionModal.vue?vue&type=style&index=0&id=be48cdb6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be48cdb6"]])

export default __exports__